import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import PlaceholderCover from '@/app/components/PlaceholderCover.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicCover',
  props: {
    position: {},
    image: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (__props.image)
    ? _withDirectives((_openBlock(), _createElementBlock("img", {
        key: 0,
        class: _normalizeClass(["dynamic-cover", `dynamic-cover--${__props.position}`]),
        crossorigin: "anonymous",
        alt: "",
        width: "110",
        height: "146"
      }, null, 2)), [
        [_directive_lazy, { src: __props.image }]
      ])
    : (_openBlock(), _createBlock(PlaceholderCover, {
        key: 1,
        class: _normalizeClass(["dynamic-cover", `dynamic-cover--${__props.position}`])
      }, null, 8, ["class"]))
}
}

})